export default "__VITE_ASSET__DCbeCaVO__"